{
  "title": "Pago",
  "subtitle": "Complete el pago del registro de su marca",
  "summary": {
    "title": "Resumen del pedido",
    "countries": "Países seleccionados",
    "classes": "Clases de Niza",
    "subtotal": "Subtotal",
    "governmentFees": "Tasas gubernamentales",
    "serviceFee": "Tarifa de servicio",
    "total": "Total",
    "taxNote": "Los precios incluyen impuestos aplicables"
  },
  "methods": {
    "title": "Método de pago",
    "card": "Tarjeta de crédito/débito",
    "cardNumber": "Número de tarjeta",
    "expiry": "Fecha de vencimiento",
    "cvc": "CVC",
    "nameOnCard": "Nombre en la tarjeta",
    "secure": "Pago seguro",
    "stripeTitle": "Pago seguro con Stripe",
    "stripeDesc": "Su pago se procesa de forma segura a través de Stripe. Nunca almacenamos la información de su tarjeta.",
    "ssl": "Cifrado SSL de 256 bits",
    "pci": "Cumple con PCI DSS",
    "cards": "Acepta todas las tarjetas principales"
  },
  "status": {
    "processing": "Procesando pago...",
    "success": "¡Pago exitoso!",
    "failed": "Pago fallido",
    "tryAgain": "Por favor intente de nuevo o use otro método de pago.",
    "pending": "Pago pendiente",
    "refunded": "Reembolsado"
  },
  "confirmation": {
    "title": "Pago confirmado",
    "thankYou": "¡Gracias por su pago!",
    "receiptSent": "Se ha enviado un recibo a {{email}}",
    "nextSteps": "Próximos pasos",
    "applicationSubmitted": "Su solicitud de marca ha sido enviada para procesamiento.",
    "viewStatus": "Ver estado del registro",
    "downloadReceipt": "Descargar recibo"
  },
  "buttons": {
    "pay": "Pagar {{amount}}",
    "payNow": "Pagar ahora",
    "reviewOrder": "Revisar pedido",
    "proceedToPayment": "Proceder al pago",
    "payAmount": "Pagar ${{amount}} - Proceder al pago seguro",
    "agreeTerms": "Acepto los",
    "terms": "Términos de servicio",
    "and": "y la",
    "privacy": "Política de privacidad"
  }
}
